var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items.length)?_c('v-container',{attrs:{"fluid":""}},[_c('v-card',[_c('v-breadcrumbs',{attrs:{"items":_vm.items}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }